export const parseTagColor = (fileNumber: null | number) => {
  if (fileNumber === null) return null;
  return (fileNumber % 15) + 1;
};
